import { render } from "./user-privtae-training.vue?vue&type=template&id=b3d296e2&scoped=true"
import script from "./user-privtae-training.vue?vue&type=script&lang=js"
export * from "./user-privtae-training.vue?vue&type=script&lang=js"

import "./user-privtae-training.vue?vue&type=style&index=0&id=b3d296e2&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d296e2"]])

export default __exports__